// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1YyMm","noInteraction":"EventWrapper_noInteraction__2jNPn"};